import MapboxDraw from "@mapbox/mapbox-gl-draw";
import CustomDrawLineString from "./modes/CustomDrawLineString";
import CustomDrawPolygon from "./modes/CustomDrawPolygon";
import CustomDrawPoint from "./modes/CustomDrawPoint";
import CustomDirectSelect from "./modes/CustomDirectSelect";
import patchSimpleSelect from "./modes/CustomSimpleSelect";
import patchDirectSelect from "./modes/CustomDirectSelect";
import { modes } from "./modes/constants";
import * as Constants from "./modes/constants";
import CustomSimpleSelect from "./modes/CustomSimpleSelect";

const DrawMapbox = new MapboxDraw({
  userProperties: true,
  defaultMode: "simple_select",

  displayControlsDefault: false,
  keybindings: true,
  touchBuffer: 10,

  // snapToVertex: false,
  // modes: {
  //   draw_line_string: CustomDrawLineStringMode,
  // },

  modes: {
    custom_draw_line_string: CustomDrawLineString,
    custom_draw_polygon: CustomDrawPolygon,
    custom_draw_point: CustomDrawPoint,
    direct_select: CustomDirectSelect,
    simple_select: CustomSimpleSelect,
    // direct_select: CustomDirectSelect,
    // ...MapboxDraw.modes,
  },

  controls: {
    polygon: true,
    trash: true,
  },
  styles: [
    // WHEN SAVED  POLYGON

    // {
    //   id: "lastDrawingSegment",
    //   source: "lastDrawingSegment",
    //   type: "line",
    //   paint: {
    //     "line-color": "#FFFFFF",
    //     "line-width": 3,
    //     "line-dasharray": [1, 1],
    //   },
    // },

    {
      id: "gl-draw-polygon-fill-inactive",
      type: "fill",
      filter: [
        "all",
        ["==", "active", "false"],
        ["==", "$type", "Polygon"],
        ["!=", "mode", "static"],
      ],
      paint: {
        // "fill-color": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "lawn",
        //   "#009A40",
        //   "#fed957",
        // ],

        "fill-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "fill-opacity": ["coalesce", ["get", "user_opacity"], 0.4],
        "fill-outline-color": "#8ED9B8",
        // "fill-opacity": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "mapbounds",
        //   0, // matching value for "mapbounds"
        //   0.4, // default value
        // ],
      },
    },
    {
      // WHEN DRAWING  POLYGON
      id: "gl-draw-polygon-fill-active",
      type: "fill",
      filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
      paint: {
        // "fill-color": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "lawn",
        //   "#009A40",
        //   "#fed957",
        // ],
        "fill-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "fill-opacity": ["coalesce", ["get", "user_opacity"], 0.4],

        "fill-outline-color": "grey",
        // "fill-opacity": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "mapbounds",
        //   0.2, // matching value for "mapbounds"
        //   0.4, // default value
        // ],
      },
    },

    // {
    //   id: "gl-draw-polygon-midpoint",
    //   type: "circle",
    //   filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
    //   paint: {
    //     "circle-radius": 3,
    //     "circle-color": "white",
    //   },
    // },
    {
      id: "gl-draw-polygon-stroke-inactive",
      type: "line",
      filter: [
        "all",
        ["==", "active", "false"],
        ["==", "$type", "Polygon"],
        ["!=", "mode", "static"],
      ],
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        // "line-color": "#CD992E",
        "line-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "line-opacity": ["coalesce", ["get", "user_opacity"], 1],
        "line-width": 2,
      },
    },
    {
      id: "gl-draw-polygon-stroke-active",
      type: "line",
      filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": "black",
        "line-dasharray": [0.2, 2],
        "line-width": 3,
      },
    },
    {
      // WHEN SAVED  LINE

      id: "gl-draw-line-inactive",
      type: "line",
      filter: [
        "all",
        ["==", "active", "false"],
        ["==", "$type", "LineString"],
        ["!=", "mode", "static"],
      ],
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        // "line-color": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "bikeLane",
        //   "pink",
        //   "black",
        // ],
        // [
        //   "match",
        //   ["get", "lineType"],
        //   "crosswalk",
        //   "green",
        //   "other",
        //   "green",
        //   "blue",
        // ],
        "line-dasharray": [1, 0],
        // "line-pattern": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "crosswalk",
        //   "CrosswalkPattern",
        //   "bikeLane",
        //   "bikeLanePattern",
        //   "path",
        //   "BlackPattern",
        //   "BlackPattern",
        // ],

        "line-color": ["coalesce", ["get", "user_color"], "black"],
        "line-opacity": ["coalesce", ["get", "user_opacity"], 1],

        "line-width": 2,
        // "line-width": [
        //   "interpolate",
        //   ["exponential", 1.5],
        //   ["zoom"],
        //   5,
        //   [
        //     "match",
        //     ["get", "user_drawType"],
        //     "bikeLane",
        //     0.1,
        //     "crosswalk",
        //     0.1,
        //     5,
        //   ],
        //   20,
        //   [
        //     "match",
        //     ["get", "user_drawType"],
        //     "bikeLane",
        //     15,
        //     "crosswalk",
        //     26,
        //     5,
        //   ],
        // ],
        // [
        //     "match",
        //     ["get", "user_drawType"], // get the property
        //     "bikeLane",
        //     5,
        //     "crosswalk",
        //     20,
        //     5,
        // ],
      },
    },

    {
      // WHEN SAVED  LINE - TRANSPARENT WIDER LINE
      id: "gl-draw-line-inactive-2",
      type: "line",
      filter: [
        "all",
        ["==", "active", "false"],
        ["==", "$type", "LineString"],
        ["!=", "mode", "static"],
      ],
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": "transparent",
        "line-width": 10,
      },
    },

    {
      // WHEN DRAWING LINE

      id: "gl-draw-line-active",
      type: "line",
      filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
      layout: {
        "line-cap": "butt",
        "line-join": "round",
      },
      paint: {
        // "line-color": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "bikeLane",
        //   "pink",
        //   "black",
        // ],

        // [
        //   "match",
        //   ["get", "lineType"],
        //   "crosswalk",
        //   "green",
        //   "other",
        //   "green",
        //   "blue",
        // ],
        "line-dasharray": [1, 0],
        // "line-pattern": [
        //   "match",
        //   ["get", "user_drawType"], // get the property
        //   "crosswalk",
        //   "CrosswalkPattern",
        //   "bikeLane",
        //   "bikeLanePattern",
        //   "path",
        //   "BlackPattern",
        //   "DashPattern",
        // ],
        // "line-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "line-color": ["coalesce", ["get", "user_color"], "black"],
        "line-opacity": ["coalesce", ["get", "user_opacity"], 1],

        "line-width": 2,
        // "line-width": [
        //   "interpolate",
        //   ["exponential", 1.5],
        //   ["zoom"],
        //   5,
        //   [
        //     "match",
        //     ["get", "user_drawType"],
        //     "bikeLane",
        //     0.1,
        //     "crosswalk",
        //     0.1,
        //     5,
        //   ],
        //   20,
        //   [
        //     "match",
        //     ["get", "user_drawType"],
        //     "bikeLane",
        //     15,
        //     "crosswalk",
        //     26,
        //     5,
        //   ],
        // ],
      },
    },
    {
      // WHEN DRAWING LINE - TRANSPARENT WIDER LINE
      id: "gl-draw-line-active-2",
      type: "line",
      filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
      layout: {
        "line-cap": "butt",
        "line-join": "round",
      },
      paint: {
        "line-color": "transparent",
        "line-width": 10,
      },
    },

    {
      id: "gl-draw-polygon-midpoint-stroke",
      type: "circle",
      filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
      paint: {
        "circle-radius": 5,
        "circle-color": "black",
      },
    },

    {
      id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "$type", "Point"],
        ["!=", "mode", "static"],
      ],
      paint: {
        "circle-radius": 8,
        "circle-color": "black",
      },
    },
    {
      id: "gl-draw-polygon-and-line-vertex-inactive",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "$type", "Point"],
        ["!=", "mode", "static"],
      ],
      paint: {
        "circle-radius": 6,
        "circle-color": "#fff",
      },
    },
    {
      id: "gl-draw-point-point-stroke-inactive",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "active", "false"],
        ["==", "$type", "Point"],
        ["==", "meta", "feature"],
        ["!=", "mode", "static"],
      ],
      paint: {
        "circle-radius": 10,
        "circle-opacity": 1,
        "circle-color": "black",
      },
    },
    {
      id: "gl-draw-point-inactive",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "active", "false"],
        ["==", "$type", "Point"],
        ["==", "meta", "feature"],
        ["!=", "mode", "static"],
      ],
      paint: {
        "circle-radius": 8,
        "circle-color": "white",
      },
    },

    {
      id: "gl-draw-point-stroke-active",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "$type", "Point"],
        ["==", "active", "true"],
        ["!=", "meta", "midpoint"],
      ],
      paint: {
        "circle-radius": 12,
        "circle-color": "black",
      },
    },
    {
      id: "gl-draw-point-active",
      type: "circle",
      filter: [
        "all",
        ["==", "meta", "vertex"],
        ["==", "$type", "Point"],
        ["!=", "meta", "midpoint"],
        ["==", "active", "true"],
      ],
      paint: {
        "circle-radius": 10,
        "circle-color": "white",
      },
    },
    // {
    //   id: "gl-draw-point-inactive-draw_point",
    //   type: "symbol",
    //   filter: [
    //     "all",
    //     ["==", "$type", "Point"],
    //     ["!=", "meta", "midpoint"],
    //     ["==", "active", "false"],
    //     ["!=", "mode", "draw_line_string"],
    //     ["!=", "mode", "draw_polygon"],
    //   ],
    //   layout: {
    //     "icon-image": "IdeaPinYellow", // Name of your custom PNG image
    //     "icon-size": 0.3, // Scale the size of the image
    //     "icon-offset": [0, -50], // Move the icon up by 10 pixels
    //   },
    // },
    {
      id: "gl-draw-point-active-draw_point",
      // type: "symbol",
      filter: [
        "all",
        ["!=", "meta", "vertex"],
        ["!=", "meta", "midpoint"],
        ["==", "$type", "Point"],
        ["==", "active", "true"],
      ],
      type: "circle",
      paint: {
        "circle-radius": 8,
        "circle-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "circle-opacity": ["coalesce", ["get", "user_opacity"], 1],

        // "circle-color": [
        //   "match",
        //   ["get", "user_number"], // get the property
        //   1,
        //   "#0a5b65",
        //   2,
        //   "#265e2a",
        //   3,
        //   "#704b03",
        //   4,
        //   "#354ca1",
        //   5,
        //   "#60438f",
        //   6,
        //   "#883559",
        //   7,
        //   "#92321f",
        //   8,
        //   "#7e4308",
        //   9,
        //   "#724926",
        //   10,
        //   "#6a6661",
        //   "#4d4843",
        // ],
        "circle-stroke-color": "#fff",
        "circle-stroke-width": 2,
        "circle-stroke-opacity": ["coalesce", ["get", "user_opacity"], 1],
      },

      // layout: {
      //   "icon-image": "IdeaPinYellow", // Name of your custom PNG image
      //   "icon-size": 0.3, // Scale the size of the image
      //   "icon-offset": [0, -50], // Move the icon up by 10 pixels
      //   // "symbol-placement": "point",
      //   // "text-ignore-placement": true,
      //   "icon-allow-overlap": true,
      //   // "icon-ignore-placement": true,
      // },
    },

    // {
    //   id: "gl-draw-point-active-draw_point_label",
    //   filter: [
    //     "all",
    //     ["!=", "meta", "vertex"],
    //     ["!=", "meta", "midpoint"],
    //     ["==", "$type", "Point"],
    //     ["==", "active", "true"],
    //   ],
    //   type: "symbol",
    //   layout: {
    //     "text-field": ["get", "user_number"],
    //     // "text-justify": "auto",
    //     // "text-variable-anchor": ["top", "bottom", "left", "right"],
    //     // TEMPORARILY FIXED IT
    //     // "text-font": ["Nunito"],
    //     "text-font": ["Open Sans Bold"],

    //     "text-size": 14,

    //     "icon-allow-overlap": true,
    //     // "text-color": "#ffffff",
    //     "text-offset": [0, 0],
    //     // "text-stroke-color": "#ffffff",
    //     // "text-stroke-width": 2,
    //   },

    //   paint: {
    //     "text-color": "white",
    //   },
    // },

    {
      id: "gl-draw-point-inactive-draw_point",
      // type: "symbol",
      filter: [
        "all",
        ["!=", "meta", "vertex"],
        ["!=", "meta", "midpoint"],
        ["==", "$type", "Point"],
        ["==", "active", "false"],
      ],
      type: "circle",
      paint: {
        "circle-radius": 6,
        "circle-color": ["coalesce", ["get", "user_color"], "#CD992E"],
        "circle-opacity": ["coalesce", ["get", "user_opacity"], 1],

        // "circle-color": [
        //   "match",
        //   ["get", "user_number"], // get the property
        //   1,
        //   "#0a5b65",
        //   2,
        //   "#265e2a",
        //   3,
        //   "#704b03",
        //   4,
        //   "#354ca1",
        //   5,
        //   "#60438f",
        //   6,
        //   "#883559",
        //   7,
        //   "#92321f",
        //   8,
        //   "#7e4308",
        //   9,
        //   "#724926",
        //   10,
        //   "#6a6661",
        //   "#4d4843",
        // ],
        "circle-stroke-color": "#fff",
        "circle-stroke-width": 2,
        "circle-stroke-opacity": ["coalesce", ["get", "user_opacity"], 1],
      },

      // layout: {
      //   "icon-image": "IdeaPinGrey", // Name of your custom PNG image
      //   "icon-size": 0.3, // Scale the size of the image
      //   "icon-offset": [0, -50], // Move the icon up by 10 pixels
      //   // "symbol-placement": "point",
      //   // "text-ignore-placement": true,
      //   "icon-allow-overlap": true,
      //   // "icon-ignore-placement": true,
      // },
    },

    // {
    //   id: "gl-draw-point-inactive-draw_point_label",
    //   type: "symbol",
    //   filter: [
    //     "all",
    //     ["!=", "meta", "vertex"],
    //     ["!=", "meta", "midpoint"],
    //     ["==", "$type", "Point"],
    //     ["==", "active", "false"],
    //   ],
    //   layout: {
    //     "text-field": ["get", "user_number"],
    //     // "text-justify": "auto",
    //     // "text-variable-anchor": ["top", "bottom", "left", "right"],
    //     // TEMPORARILY FIXED IT
    //     // "text-font": ["Nunito Bold"],
    //     "text-font": ["Open Sans Bold"],
    //     "text-size": 12,
    //     "text-allow-overlap": true,

    //     // "text-color": "#ffffff",
    //     "text-offset": [0, 0],
    //     // "text-stroke-color": "#ffffff",
    //     // "text-stroke-width": 2,
    //   },

    //   paint: {
    //     "text-color": "white",
    //   },
    // },

    // {
    //   id: "gl-draw-polygon-fill-static",
    //   type: "fill",
    //   filter: [
    //     "all",
    //     ["==", "mode", "static"],
    //     ["==", "$type", "Polygon"],
    //   ],
    //   paint: {
    //     "fill-color": "#404040",
    //     "fill-outline-color": "#404040",
    //     "fill-opacity": 1,
    //   },
    // },
    // {
    //   id: "gl-draw-polygon-stroke-static",
    //   type: "line",
    //   filter: [
    //     "all",
    //     ["==", "mode", "static"],
    //     ["==", "$type", "Polygon"],
    //   ],
    //   layout: {
    //     "line-cap": "round",
    //     "line-join": "round",
    //   },
    //   paint: {
    //     "line-color": "#404040",
    //     "line-width": 2,
    //   },
    // },
    // {
    //   id: "gl-draw-line-static",
    //   type: "line",
    //   filter: [
    //     "all",
    //     ["==", "mode", "static"],
    //     ["==", "$type", "LineString"],
    //   ],
    //   layout: {
    //     "line-cap": "round",
    //     "line-join": "round",
    //   },
    //   paint: {
    //     "line-color": "#404040",
    //     "line-width": 2,
    //   },
    // },
    // {
    //   id: "gl-draw-point-static",
    //   type: "circle",
    //   filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
    //   paint: {
    //     "circle-radius": 5,
    //     "circle-color": "blue",
    //   },
    // },

    // end default themes provided by MB Draw
    // end default themes provided by MB Draw
    // end default themes provided by MB Draw
    // end default themes provided by MB Draw

    // new styles for toggling colors
    // new styles for toggling colors
    // new styles for toggling colors
    // new styles for toggling colors

    // {
    //   id: "gl-draw-polygon-color-picker",
    //   type: "fill",
    //   filter: [
    //     "all",
    //     ["==", "$type", "Polygon"],
    //     ["has", "user_portColor"],
    //   ],
    //   paint: {
    //     "fill-color": ["get", "user_portColor"],
    //     "fill-outline-color": ["get", "user_portColor"],
    //     "fill-opacity": 0.5,
    //   },
    // },
    // {
    //   id: "gl-draw-line-color-picker",
    //   type: "line",
    //   filter: [
    //     "all",
    //     ["==", "$type", "LineString"],
    //     ["has", "user_portColor"],
    //   ],
    //   paint: {
    //     "line-color": ["get", "user_portColor"],
    //     "line-width": 2,
    //   },
    // },
    // {
    //   id: "gl-draw-point-color-picker",
    //   type: "circle",
    //   filter: [
    //     "all",
    //     ["==", "$type", "Point"],
    //     ["has", "user_portColor"],
    //   ],
    //   paint: {
    //     "circle-radius": 3,
    //     "circle-color": ["get", "user_portColor"],
    //   },
    // },
    {
      id: "gl-draw-direct-select-line",
      type: "line",
      filter: [
        "all",
        ["==", "$type", "LineString"],
        ["==", "meta", "direct_select_line"],
      ],
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": "#3b9ddd",
        "line-width": 2,
      },
    },
  ],
  // Set mapbox-gl-draw to draw by default.
  // The user does not have to click the polygon control button first.
});

export default DrawMapbox;
